import {
  colors,
  spacing,
  fontSizes,
  fonts,
} from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";
export const localStyles = stylex.create({
  sitemap: {
    display: { default: "grid", "@media (min-width: 1024px)": "flex" },
    width: "100%",
    gridTemplateColumns: {
      default: "repeat(2, minmax(0, 1fr))",
      "@media (min-width: 768px)": "repeat(3, minmax(0, 1fr))",
    },
    alignItems: "start",
    columnGap: spacing.space24,
    rowGap: 36,
    overflow: "clip",
    flexWrap: "nowrap",
    justifyContent: {
      default: "normal",
      "@media (min-width: 1024px)": "space-between",
    },
  },
  column: {
    display: "flex",
    width: { default: "100%", "@media (min-width: 1024px)": 180 },
    flexDirection: "column",
    alignItems: "flex-start",
    gap: spacing.space12,
    wordBreak: "break-word",
    whiteSpace: { default: "normal", "@media (min-width: 1024px)": "nowrap" },
    color: colors.inverse,
    fontSize: fontSizes.label,
    fontStyle: "normal",
    lineHeight: "normal",
  },
  products: { gap: 10, overflow: "clip" },
  about: {
    order: { default: 0, "@media (max-width: 767px)": 1 },
    gap: { default: spacing.space12, "@media (pointer: coarse)": 0 },
  },
  heading: {
    margin: 0,
    fontFamily: fonts.mono,
    fontSize: fontSizes.label,
    fontWeight: 700,
    lineHeight: "normal",
    letterSpacing: "1.26px",
    wordBreak: "break-word",
    whiteSpace: "nowrap",
    color: colors.inverse,
    fontStyle: "normal",
  },
  links: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: { default: 10, "@media (pointer: coarse)": 0 },
  },
});
